<template>
  <div>
    <validation-observer ref="refFormObserver">
      <b-form>
        <!-- Lista de contactos -->
        <div v-for="(contact, index) in itemData.emergency_contact" :key="index">
          <b-row class="mb-2">
            <b-col cols="2">
              <validation-provider
                #default="validationContext"
                 :vid="`section_${index}`"
                :name="$t('unit.section')"
                rules="required"
              >
                <b-form-group
                  :label="$t('unit.section')"
                  :state="getValidationState(validationContext)"
                >
                  <v-select
                    v-model="contact.section"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="teamsOptions"
                    :reduce="(val) => val.label"
                    :input-id="`section_${index}`"
                  />
                  <b-form-invalid-feedback :state="getValidationState(validationContext)">
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="2">
              <validation-provider
                #default="validationContext"
                :vid="`phone_number_${index}`"
                :name="$t('unit.phone_number')"
                rules="required"
              >
                <b-form-group
                  :label="$t('unit.phone_number')"
                  :state="getValidationState(validationContext)"
                >
                  <b-form-input
                    v-model="contact.phone_number"
                    :state="getValidationState(validationContext)"
                    trim
                  />
                  <b-form-invalid-feedback>
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="2">
              <validation-provider
                #default="validationContext"
                :vid="`name_${index}`"
                :name="$t('unit.name')"
                rules="required"
              >
                <b-form-group
                  :label="$t('unit.name')"
                  :state="getValidationState(validationContext)"
                >
                  <b-form-input
                    v-model="contact.name"
                    :state="getValidationState(validationContext)"
                    trim
                  />
                  <b-form-invalid-feedback>
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="4">
              <validation-provider
                #default="validationContext"
                :vid="`description_${index}`"
                :name="$t('unit.description')"
                rules="required"
              >
                <b-form-group
                  :label="$t('unit.description')"
                  :state="getValidationState(validationContext)"
                >
                  <b-form-input
                    v-model="contact.description"
                    :state="getValidationState(validationContext)"
                    trim
                  />
                  <b-form-invalid-feedback>
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="auto">
              <div class="form-group mb-0">
                <label class="d-block">&nbsp;</label>
                <b-button variant="danger" @click="removeContact(index)" class="mr-2">
                  {{ $t('unit.remove_contact') }}
                </b-button>
              </div>
            </b-col>
          </b-row>
        </div>

        <!-- Botón para añadir un nuevo contacto -->
        <b-button variant="secondary" @click="addContact">{{ $t('unit.add_contact') }}</b-button>
      </b-form>
    </validation-observer>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BButton,
  BForm,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
} from "bootstrap-vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import formValidation from "@/@core/comp-functions/forms/form-validation";
import { ref, computed, watch } from "@vue/composition-api";
import vSelect from "vue-select";
import store from "@/store";

export default {
  name: "EmergencyContacts",
  components: {
    BCard,
    BRow,
    BCol,
    BButton,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    ValidationProvider,
    ValidationObserver,
    vSelect,
  },
  props: {
    isAdd: {
      type: Boolean,
      default: false,
    },
    propItemData: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props, { emit }) {
    const { refFormObserver, getValidationState } = formValidation();

    // Section is picked from the teams catalog, but only its name is stored
    // (see the `reduce` on the v-select), so free-text sections saved before
    // this change keep rendering as-is.
    store.dispatch("teams/getAll");
    const teamsOptions = computed(() => store.getters["teams/getSelectedItems"]);

    const itemData = ref({
      ...props.propItemData,
      emergency_contact: props.propItemData.emergency_contact || []
    });

    // Add a watch for the entire itemData.value.emergency_contact array
    watch(
      () => itemData.value.emergency_contact,
      () => {
        emit("update:itemData", itemData.value);
      },
      { deep: true }
    );

    const addContact = () => {
      if (!itemData.value.emergency_contact) {
        itemData.value.emergency_contact = [];
      }
      itemData.value.emergency_contact.push({
        section: "",
        name: "",
        phone_number: "",
        description: "",
      });
      emit("update:itemData", itemData.value);
    };

    const removeContact = (index) => {
      itemData.value.emergency_contact.splice(index, 1);
      emit("update:itemData", itemData.value);
    };

    // Validación del paso
    const validateStep = async () => {
      return await refFormObserver.value.validate();
    }

    return {
      itemData,
      teamsOptions,
      validateStep,
      addContact,
      removeContact,
      refFormObserver,
      getValidationState,
    };
  },
};
</script>
